export const AREA_SEARCH_PROPS = {
  placeholder: String, // 默认回显ID
  updateRenderData: Function, // 更新数据
  handleEvent: Function, // 事件派发
  searchOption: Object, // 输入框参数
  level: {
    type: [Number, String],
    default: 5
  },
  handleSearchInputEvent: Function,
  disabled: Boolean
}



// WEBPACK FOOTER //
// ./src/public/components/kye-area/props/area-search.js